import { useTranslation } from 'react-i18next';
import { Modal, Button, Form } from 'reactstrap';
import { ColumnSelection } from 'types/common/Table';

interface ColumnSelectionModalProps {
  AllColumn: ColumnSelection[];
  visibleColumns: string[];
  isColumnModalOpen: boolean;
  exceptedColumn: string[];
  toggleColumnModal: () => void;
  handleColumnVisibilityChange: (columnId: string, isChecked: boolean) => void;
}

const ColumnSelectionModal = ({
  AllColumn,
  visibleColumns,
  isColumnModalOpen,
  exceptedColumn = [],
  toggleColumnModal,
  handleColumnVisibilityChange,
}: ColumnSelectionModalProps) => {
  const { t } = useTranslation();

  const allSelected = AllColumn.every(
    (column) =>
      visibleColumns.includes(column.id) || exceptedColumn.includes(column.id)
  );

  const handleToggleAll = (isChecked: boolean) => {
    if (isChecked) {
      const allVisible = AllColumn.map((column) => column.id).filter(
        (id) => !exceptedColumn.includes(id)
      );
      allVisible.forEach((columnId) =>
        handleColumnVisibilityChange(columnId, true)
      );
    } else {
      AllColumn.forEach(({ id }) => {
        if (!exceptedColumn.includes(id)) {
          handleColumnVisibilityChange(id, false);
        }
      });
    }
  };
  return (
    <>
      <i
        className="mdi mdi-filter-menu px-1"
        style={{
          fontSize: '1rem',
          cursor: 'pointer',
        }}
        onClick={toggleColumnModal}
        title={t('Visible Columns')}
      ></i>

      <Modal isOpen={isColumnModalOpen} toggle={toggleColumnModal}>
        <div className="modal-header">
          <h5 className="modal-title">{t('Visible Columns')}</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={toggleColumnModal}
          ></button>
        </div>
        <div className="modal-body">
          <Form>
            <div className="form-check">
              <input
                type="checkbox"
                id="toggle-all"
                className="form-check-input"
                checked={allSelected}
                onChange={(e) => handleToggleAll(e.target.checked)}
              />
              <label htmlFor="toggle-all" className="form-check-label">
                {t('Select All')}
              </label>
            </div>
            {AllColumn.map((column: ColumnSelection) => (
              <div key={column.id} className="form-check">
                <input
                  type="checkbox"
                  id={`column-${column.id}`}
                  className="form-check-input"
                  checked={visibleColumns.includes(column.id)}
                  onChange={(e) =>
                    handleColumnVisibilityChange(column.id, e.target.checked)
                  }
                  disabled={exceptedColumn.includes(column.id) ? true : false}
                />
                <label
                  htmlFor={`column-${column.id}`}
                  className="form-check-label"
                >
                  {column.name}
                </label>
              </div>
            ))}
          </Form>
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={toggleColumnModal}>
            {t('Btn_Close')}
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default ColumnSelectionModal;
